import React, { FC, useEffect } from 'react';
import { Form, Row, Col } from 'antd';
import { FormContent } from '@maxtropy/components';
import ShowInput from '@/shared/components/ShowInput';
import { BatchDeviceTemplatePropertyResponse } from '../../../../api/batch';

interface BaseInfoProps {
  data?: BatchDeviceTemplatePropertyResponse;
}

const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

const BaseInfo: FC<BaseInfoProps> = ({ data }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
      });
    }
  }, [data, form]);

  return (
    <Form form={form} {...formLayout} labelAlign="left">
      <FormContent title="设备信息">
        <Row>
          <Col span={12}>
            <Form.Item name="typeName" label="所属类目">
              <ShowInput />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="modelName" label="所属型号">
              <ShowInput />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="modelNo" label="物模型型号">
              <ShowInput />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="第三方对接">{data?.thirdParty ? '是' : '否'}</Form.Item>
          </Col>
        </Row>
      </FormContent>
    </Form>
  );
};

export default BaseInfo;
